import { Metrica } from "../components/context/CityContext";

export const getYmAccountId = () => Metrica.Magnitogorsk;
